export default __webpack_public_path__ + "static/media/SearchIcon.2dc5a41c.svg";